module.exports = {
  siteName: "4x4 Driving School",
  siteTitle: `4x4 Driving School | Cardiff South Wales`, // Site title.
  siteTitleAlt: "Cardiff South Wales", // Alternative site title for SEO.
  siteLogo: "/logos/logo-1024.png", // Logo used for SEO and manifest.
  siteUrl: "https://vagr9k.github.io", // Domain of your website without pathPrefix.
  siteEmail: "4x4drivingschool@gmail.com",
  siteDescription: "Book today for your real 4x4 off road experience that really is like no other. Based in South Wales just north of Cardiff this is where you can really get down and dirty in the mud in our purpose-built course.", // Website description used for RSS feeds/meta description tag.
  sitePhone: "07812 210 484",
  siteFBAppID: "1825356251115265", // FB Application ID for using app insights
  siteGATrackingID: "UA-47311644-4", // Tracking code ID for google analytics.
  copyright: "Copyright © 2017. 4x4 Driving School", // Copyright string for the footer of the website and RSS feed.
  siteOfficeAddress: "2 Springfield Gardens, CF15 8LQ",
  siteAddress: "Off Road Centre,<br \/>Ty Rhiw Farm, <br \/>Beechwood Road, <br \/>Taffs well <br \/>CF15 7RZ",
  siteAddressShort: "Off Road Centre, Ty Rhiw Farm, Taffs well, CF15 7RZ",
  fullDayPrice: "£199",
  halfDayPrice: "£100",
  siteLat: 51.546241,
  siteLng: -3.257075
}


// WEBPACK FOOTER //
// ./data/siteConfig.js